import{jsx as o}from"react/jsx-runtime";import{Component as e}from"react";import n,{keyframes as t,css as i}from"styled-components";import{calculateRem as r}from"@vds-core/utilities";import{ComponentTokens as a}from"@vds-tokens/component";const d=t`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`,l=t`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`,c=n.div.withConfig({displayName:"Overlay",componentId:"VDS__sc-1fehsb0-0"})`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${function({surface:o}){return"dark"===o?a.tooltip.native.background.overlay.ondark.value:a.tooltip.native.background.overlay.onlight.value}};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  padding: ${r(16)};

  ${function({dialogOpened:o,opened:e}){return(o||e)&&i`
      animation: 0.1s linear 0s ${d};
    `}};

  ${function({$unmounted:o}){return o&&i`
      animation: 0.1s linear 0s ${l};
    `}};
`;class s extends e{render(){var e=this;const{children:n,fullScreenDialog:t,noMobilePadding:i,viewport:r,surface:a,dialogOpened:d,unmounted:l}=this.props;return o(c,{fullScreenDialog:t,noMobilePadding:i,viewport:r,surface:a,$dialogOpened:d,$unmounted:l,ref:function(o){e.overlayRef=o},children:n})}}export{s as default};
